/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateWidgetRequestBody,
  UpdateWidgetRequestBody$Outbound,
  UpdateWidgetRequestBody$outboundSchema,
} from "../components/updatewidgetrequestbody.js";

export type UpdateWidgetSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateWidgetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateWidgetRequestBody: UpdateWidgetRequestBody;
};

/** @internal */
export type UpdateWidgetSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateWidgetSecurity$outboundSchema: z.ZodMiniType<
  UpdateWidgetSecurity$Outbound,
  UpdateWidgetSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateWidgetSecurityToJSON(
  updateWidgetSecurity: UpdateWidgetSecurity,
): string {
  return JSON.stringify(
    UpdateWidgetSecurity$outboundSchema.parse(updateWidgetSecurity),
  );
}

/** @internal */
export type UpdateWidgetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateWidgetRequestBody: UpdateWidgetRequestBody$Outbound;
};

/** @internal */
export const UpdateWidgetRequest$outboundSchema: z.ZodMiniType<
  UpdateWidgetRequest$Outbound,
  UpdateWidgetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateWidgetRequestBody: UpdateWidgetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateWidgetRequestBody: "UpdateWidgetRequestBody",
    });
  }),
);

export function updateWidgetRequestToJSON(
  updateWidgetRequest: UpdateWidgetRequest,
): string {
  return JSON.stringify(
    UpdateWidgetRequest$outboundSchema.parse(updateWidgetRequest),
  );
}
